export const CONFIRM_ACCOUNT_DELETION_MUTATION = `
  mutation ConfirmAccountDeletionMutation($token: String!) {
    public {
      confirmAccountDeletion(token: $token)
    }
  }
`;
